import DiscountTag from '@/components/hotels/DiscountTag';
import CheckIcon from '@/components/icons/CheckIcon';
import { currencies } from "@/constants/currencies";
import { useUserStore } from '@/core/stores/user';
import useWebbedStore from '@/core/stores/webbed';
import useToast from '@/hooks/useToast';
import { NewWebbedRoomDetails } from '@/types/webbeds';
import { calculateHotelPrices } from '@/utils/calculateHotelPrices';
import { faTag, faUser } from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Cookies from 'js-cookie';
import { Dispatch, SetStateAction } from 'react';
interface Props {
    room: NewWebbedRoomDetails,
    duration: number
    mainRoomIndex: number;
    totalPassenger: number;
    roomIndex: number;
    minMaxChildrenAges: number[] | undefined;
    setActiveRoomDetail: Dispatch<SetStateAction<{
        mainRoomIndex: number;
        roomIndex: number;
    } | null>>
}

export const RoomCard = ({ setActiveRoomDetail, duration, minMaxChildrenAges, totalPassenger, room, mainRoomIndex, roomIndex, }: Props) => {

    const showingRate = room.minPrice
    const { addActions } = useUserStore()
    const { errorToast } = useToast()
    const { selectedRooms, } = useWebbedStore()

    const selectedRoom = selectedRooms.find(item => item.roomTypeId === room.roomTypeId && (item.roomIndex === mainRoomIndex))

    const currency = Cookies.get('currency') || 'USD'

    const rateOffer = room.rateBases[0]
    const offerAmount = rateOffer.offers ? calculateHotelPrices(rateOffer.price, rateOffer.offers.charge, duration) : null
    return (
        <>
            <div className={`${selectedRoom ? (selectedRoom.orderStatus === 'unsuccessful' || totalPassenger > Number(room.maxOccupancy) ? 'border-rose-300 hover:!border-rose-500' : 'border-secondary-500') : 'border-gray-300'} 
            flex border rounded-3xl shadow-md
                             hover:border-secondary-300 hover:shadow   transition-all duration-200 flex-col w-full px-4 py-4 col-span-4 
                             lg:col-span-2 relative overflow-hidden pb-3 cursor-pointer`}>
                <div onClick={() => {
                    addActions({ type: 'click', message: 'opened room details' })
                    // toggleSelectedRoom(room)
                    if (totalPassenger > Number(room.maxOccupancy)) {
                        errorToast('Your travelers exceed the maximum capacity for this room.')
                        return
                    }
                    if (minMaxChildrenAges && minMaxChildrenAges[1] < Number(room.minChildAge)) {
                        errorToast(`  This room has a minimum child age limit of ${room.minChildAge}, which exceeds the age age of the travelers you selected.`)
                        return
                    }
                    if (minMaxChildrenAges && minMaxChildrenAges[0] > Number(room.maxChildAge)) {
                        errorToast(` This room has a maximum child age limit of ${room.maxChildAge}, which is less than the age of the travelers you selected.`)
                        return
                    }
                    setActiveRoomDetail({ mainRoomIndex: mainRoomIndex, roomIndex: roomIndex })
                }}
                    className="grow flex flex-row"
                >
                    <div className="flex grow flex-col relative">
                        {selectedRoom && selectedRoom.orderStatus === 'unsuccessful' ?
                            <div className='py-1 w-fit absolute top-0 right-0 shadow-sm px-2 flex items-center gap-1 bg-pastel-red rounded-full text-main-800 text-sm font-normal'>
                                <CheckIcon className='w-4' />

                                <span>Not Available</span>
                            </div>
                            : selectedRoom &&
                            <div className='py-1 w-fit absolute z-30 top-0 right-0 shadow-sm px-2 flex items-center gap-1 bg-pastel-green rounded-full text-gray-800 text-sm font-normal'>
                                <CheckIcon className='w-4' />

                                <span>Selected</span>
                            </div>
                        }
                        <div className="flex flex-col ">
                            <p className="pb-1 text-sm font-semibold capitalize text-gray-800 line-clamp-2">
                                {room.name?.toLowerCase()}
                            </p>
                            <div className={`${totalPassenger > Number(room.maxOccupancy) ? 'text-rose-500' : 'text-neutral-700'} flex items-center gap-2 mt-1`}>
                                <FontAwesomeIcon icon={faUser} className='text-sm' />
                                <p className={`text-xs`}><span className='font-semibold '>
                                    Max Occupancy:</span>
                                    {room.maxOccupancy}
                                </p>
                            </div>
                            {totalPassenger > Number(room.maxOccupancy) &&
                                <p className='text-xs  mt-2 text-red-500 font-normal'>
                                    Your travelers exceed the maximum capacity for this room.
                                </p>}
                            {minMaxChildrenAges && minMaxChildrenAges[0] > Number(room.maxChildAge) &&
                                <p className='text-xs  mt-2 text-red-500 font-normal'>
                                    This room has a maximum child age limit of {room.maxChildAge}, which is less than the age of the travelers you selected..
                                </p>}
                            {minMaxChildrenAges && minMaxChildrenAges[1] < Number(room.minChildAge) &&
                                <p className='text-xs  mt-2 text-red-500 font-normal'>
                                    This room has a minimum child age limit of {room.minChildAge}, which exceeds the age age of the travelers you selected.
                                </p>}
                            {selectedRoom?.orderStatus === 'unsuccessful' &&
                                <p className='text-xs  mt-2 text-red-500'>
                                    The room option you selected is not currently available for booking, please try to remove it and select another one.
                                </p>}
                            <div className="">
                                {/* {room.rateBases[0].cancellationRules.map((policy, index) => Number(policy.charge) > 0 && (
                                    <div
                                        key={index}
                                        className=" text-xs "
                                    >
                                        <div className="">
                                            <span className=' font-semibold'>Cancellation: </span>
                                            <span className="text-gray-600 font-medium leading-5">
                                                From {policy.fromDate && formatDate(policy.fromDate)} charges <span className='text-rose-500'> ${policy.charge}</span>
                                            </span>
                                        </div>
                                    </div>
                                ))} */}
                            </div>
                            <div className='mx-auto flex  flex-col min-w-fit gap-2.5 items-end relative mr-0'>
                                {(!!offerAmount && offerAmount.discountPercent > 0) &&
                                    <DiscountTag className='relative !left-auto !right-0 min-w-fit text-nowrap' discountPercent={offerAmount.discountPercent} />}
                                <div >

                                    {currencies[currency]}
                                    {(+showingRate).toFixed(2)}
                                </div>
                            </div>
                            <div className="flex flex-col gap-2 bg-black">

                                {/* <div className="text-gray-500 text-xs flex flex-row gap-1 items-center">
                                    <FontAwesomeIcon icon={faUser} />
                                    <span className="text-neutral-800 ps-1">Sleeps:</span>
                                    <p className="text-neutral-800 font-normal">
                                        <span>{roomDetails?.maxAdults} </span>
                                        <span>{roomDetails?.maxAdults > 1 ? "Adults, " : "Adult"}</span>
                                        {roomDetails?.maxChildren > 0 &&
                                            <>
                                                <span> {roomDetails?.maxChildren} </span>
                                                <span>{roomDetails?.maxChildren > 1 ? "Children" : "child"}</span>
                                            </>
                                        }
                                    </p>
                                </div> */}

                            </div>
                            <div className="mb-2 line-clamp-1 hidden flex-row flex-wrap gap-2">

                            </div>

                        </div>
                        <div className="flex grow flex-col">
                            <div className="flex grow flex-col  justify-between">
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </>
    );
};
